import { connect } from "react-redux";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { resetError } from "../../redux/error/action";

const ErrorModal = ({ errorReducer, resetError }) => {
  const {
    modalErrorVisible,
    errorTitle,
    errorMessage,
  } = errorReducer;

  return (
    <Modal
      centered
      isOpen={modalErrorVisible}
      backdrop="static"
      keyboard={false}
      toggle={resetError}
    >
      <ModalHeader toggle={resetError}>{errorTitle}</ModalHeader>
      <ModalBody>{errorMessage}</ModalBody>
      <ModalFooter>
        <Button onClick={resetError} variant="secondary">
          Ho Capito!
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    errorReducer: state.errorReducer,
  };
};

export default connect(mapStateToProps, { resetError })(ErrorModal);
